import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "property";

export const usePropertyStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "id");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchOne, baseFetchAll, baseSave, watchRemoteResourceChange } = useBase(storeName);

  const empty = {};
  const path = "properties";

  const save = async (resource, callback, errorCallback) => {
    return await baseSave(path, resource, callback, errorCallback);
  };

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll(path, errorCallback);
  };

  const fetchOne = async (id, errorCallback) => {
    return await baseFetchOne(path, id, errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    all,
    currentPage,
    empty,
    fetchAll,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: paginatedResources,
    paginationRange,
    save,
    searchQuery,
    sorted: sortedResources,
    totalPages,
  };
});
